import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { get } from "lodash";
import moment from "moment";

import DivisionAdd from "./DivisionAdd";
import RolesContext from "../../contexts/RolesContext";
import ResourceIndex from "../Shared/ResourceIndex/ResourceIndex";
import { DivisionContext } from "../../contexts/DivisionContext";

export interface IDivisionsProps {}

const Divisions: React.FC<IDivisionsProps> = () => {
  const roleStore = useContext(RolesContext);
  const divisionContext = useContext(DivisionContext);
  const [showArchived, setShowArchived] = useState(false);

  useEffect(() => {
    divisionContext.setDisableSwitcher(true);
    return () => divisionContext.setDisableSwitcher(false);
  }, []);

  return (
    <div>
      <ResourceIndex
        resourceName={showArchived ? "archivedDivisions" : "divisions"}
        resourceTableHeaders={[
          ["Name", "name"],
          ["Created At", "createdAt"],
          ...(showArchived ? [["Archived On", "archived_at"] as [string, string]] : []),
        ]}
        resourceSearchProps={["name"]}
        enableRead={roleStore.userHasPermission("read", "Divisions")}
        enableClick={
          roleStore.userHasPermission("update", "Divisions") ? true : false
        }
        enablePagination={false}
        enableCallToAction={
          !showArchived && roleStore.userHasPermission("create", "Divisions")
        }
        callToActionContent="Add Division"
        renderReader={(division: any) => (
          <Redirect push to={`/divisions/${division.id}`} />
        )}
        renderCallToAction={(handleClose: any) => (
          <DivisionAdd handleClose={handleClose} />
        )}
        hideCallToActionInMobile={false}
        extraHeaderActions={
          roleStore.userHasPermission("update", "Divisions") ? (
            <button
              className="outline"
              onClick={() => setShowArchived((prev) => !prev)}
            >
              {showArchived ? "Show Active" : "Show Archived"}
            </button>
          ) : undefined
        }
        renderRowCell={(row: any, propName: string) => {
          const value = get(row, propName);

          if (propName === "name" && showArchived) {
            return (
              <span>
                {value}{" "}
                <span
                  style={{
                    fontSize: "0.75rem",
                    background: "#e0e0e0",
                    color: "#555",
                    borderRadius: "3px",
                    padding: "1px 6px",
                    marginLeft: "6px",
                  }}
                >
                  Archived
                </span>
              </span>
            );
          }

          if (propName === "archived_at" && value) {
            return moment(value).format("MM-DD-YYYY");
          }

          return value;
        }}
      />
    </div>
  );
};

export default Divisions;
